import { Field, FieldProps } from 'formik';
import { IEditField } from './formTools';
import { FormHelp, Input, Text } from '@zillow/constellation';
import React from 'react';
import { ITaskEditFormDisplayProps } from './TaskEditForm';
import { EditFieldControls } from './EditFieldControls';
import { FlexGrowFormField } from './FlexGrowFormField';

export const EditTaskDescriptionDisplay: React.FC<ITaskEditFormDisplayProps> = ({ task }) => {
  return <Text fontType={'bodySmall'}>{task.description}</Text>;
};

export const EditTaskDescriptionField: React.FC<IEditField> = () => {
  return (
    <EditFieldControls fieldName="description">
      <Field name={'description'}>
        {({ field, meta }: FieldProps) => {
          return (
            <FlexGrowFormField
              error={!!meta.error}
              description={<FormHelp>{meta.error}</FormHelp>}
              required
              control={
                <Input
                  {...field}
                  required
                  placeholder="Task Description"
                  value={field.value ?? ''}
                  onChange={field.onChange}
                />
              }
            />
          );
        }}
      </Field>
    </EditFieldControls>
  );
};
